'use client'

import {
  AnalyticsEntityType,
  AnalyticsSource,
  FormattedMessage,
} from '@b-stock/fe-core/bstock-react'

import { BaseCarousel } from '@/components/common/carousel/BaseCarousel'
import { useListingSearch } from '@/components/listings/search/ListingSearchProvider'
import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'

export default function NewBuyerCarousel() {
  const { data, isLoading } = useListingSearch()
  const { track } = useAnalytics()

  const handleViewAllClick = () => {
    track('button_click', {
      button_name: 'carousel_view_all',
      carousel_name: 'new_buyer',
      screen_name: 'homepage',
      source: AnalyticsSource.HOME_PORTAL,
      entityType: AnalyticsEntityType.BUYER,
    })
  }

  return (
    <BaseCarousel
      data={data}
      isLoading={isLoading}
      title={<FormattedMessage id="Common.Carousel.newBuyerTitle" />}
      viewMoreUrl="/all-auctions?starterLots=true"
      viewMoreText={<FormattedMessage id="Common.Carousel.viewAll" />}
      onViewAllClick={handleViewAllClick}
      carouselName="new_buyer"
      showMobileButton
      enableGTMTracking={false}
    />
  )
}
